import React from "react";
import { AccordionDetails } from "@mui/material";
import { ParentProps } from "../types";
import "./styles.scss";

export function ScdAccordionDetails(props: ParentProps): React.JSX.Element {
  const { children } = props;

  return (
    <AccordionDetails classes={{ root: "scd-accordion-details" }}>
      {children}
    </AccordionDetails>
  );
}
